import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { UIControlService } from 'src/app/shared/uicontrol.service';
import { IdentityService } from 'src/app/security/identity.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})
export class SideNavComponent implements OnInit {
  public showSideNav$: Observable<boolean>;

  public isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map(result => result.matches));

  public isTablet$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Tablet)
    .pipe(map(result => result.matches));

  public routeLoading = true;
  public disabled = true;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private uiControlService: UIControlService,
    public identity: IdentityService,
    private router: Router
  ) {}

  public ngOnInit() {
    this.showSideNav$ = this.uiControlService.sideNavOpen$.asObservable();

    this.router.events.subscribe(event => {
      // close sidenav on routing
      this.uiControlService.sideNavOpen$.next(false);
    });
  }

  public onActivate(): void {
    this.routeLoading = false;
  }

  public closeSideNav(): void {
    this.uiControlService.sideNavOpen$.next(false);
  }
}
